// extracted by mini-css-extract-plugin
module.exports = {"lottie":"styles_lottie__2r0Dz"};